import React from 'react';

import { formatRate } from 'src/components/pipelines/hooks/use-pipelines-timeseries';
import { TestFailureRateData } from 'src/components/pipelines/hooks/use-test-failure-rate';
import { useIntl } from 'src/hooks/intl';

import { messages } from '../metric-cards/i18n';

import { AverageChart } from './average-chart';
import { declineValueComparator } from './utils';

/* eslint @typescript-eslint/ban-types: "warn" */
export const AverageTestFailureRate: React.FC<TestFailureRateData> = props => {
  const { formatMessage } = useIntl();

  return (
    <AverageChart
      {...props}
      showLastWeekValue={false}
      yScaleZero={false}
      chartType="line"
      chartConfig={[
        {
          dataKey: 'failureRate',
        },
      ]}
      tooltipConfig={[
        {
          dataAccessor: data => formatRate(data?.failureRate),
          label: formatMessage(messages.failureRate),
        },
        {
          dataAccessor: data => data?.passed?.toLocaleString(),
          label: formatMessage(messages.passed),
        },
        {
          dataAccessor: data => data?.failed?.toLocaleString(),
          label: formatMessage(messages.failed),
        },
        {
          dataAccessor: data => data?.skipped?.toLocaleString(),
          label: formatMessage(messages.skipped),
        },
        {
          dataAccessor: data => data?.total?.toLocaleString(),
          label: formatMessage(messages.count),
        },
      ]}
      chartValueComparator={declineValueComparator}
      dataFormatter={formatRate}
      chartTitle={formatMessage(messages.testFailureRateTitle)}
    />
  );
};
